// Recently searched store

"use client"

import { create } from "zustand"
import { createJSONStorage, persist } from "zustand/middleware"

// Maximum number of recent searches to store
const MAX_RECENT_SEARCHES = 5

interface RecentlySearchedState {
  // State
  keywords: string[]

  // Actions
  addKeyword: (keyword: string) => void
  removeKeyword: (keyword: string) => void
  clearKeywords: () => void
}

export const useRecentlySearchedStore = create<RecentlySearchedState>()(
  persist(
    (set, get) => ({
      keywords: [],

      addKeyword: (keyword: string) => {
        if (!keyword.trim()) return

        set((state) => {
          // Create a new array without the keyword (if it exists)
          const filteredKeywords = state.keywords.filter(
            (k) => k.toLowerCase() !== keyword.toLowerCase()
          )

          // Add the keyword to the beginning of the array
          const newKeywords = [keyword, ...filteredKeywords]

          // Limit the array to MAX_RECENT_SEARCHES
          return {
            keywords: newKeywords.slice(0, MAX_RECENT_SEARCHES),
          }
        })
      },

      removeKeyword: (keyword: string) => {
        set((state) => ({
          keywords: state.keywords.filter(
            (k) => k.toLowerCase() !== keyword.toLowerCase()
          ),
        }))
      },

      clearKeywords: () => {
        set({ keywords: [] })
      },
    }),
    {
      name: "be:food:recently-searched-storage",
      storage: createJSONStorage(() => localStorage),
    }
  )
)
